var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-header-title"},[_vm._v(_vm._s(_vm.$t('components.suppliers.purchasePayments')))]),(
          _vm.$parent.item.stat == 1 &&
          _vm.$site.purchasePayments_allow &&
          (_vm.$user.admin ||
            _vm.$user.role.purchase_payments_add)
        )?_c('router-link',{staticClass:"btn btn-sm btn-primary",attrs:{"title":"$t('components.suppliers.addBatch')","to":'/purchasePayments/create?supplier_id=' + _vm.$route.params.id}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('components.suppliers.addition'))+" ")]):_vm._e()],1),_c('indexTable',{attrs:{"searchText":_vm.$t('components.suppliers.searchForBatch'),"withoutCard":true,"emptyTableText":_vm.$t('purchasePayments.thereAreNoPurchasePayments'),"filter":{supplier_id: _vm.$route.params.id},"emptyTableSubText":_vm.$t('allerts.TryAddingSomeItemsToTheTableAndTryAgain'),"cloumns":[
        { column: 'code', title: _vm.$t('components.suppliers.Paid'), type: 'mainLink', sort: true },
        {
          column: 'client_type',
          title: _vm.$t('components.suppliers.supplierName'),
          type: 'clintLink',
          sort: true,
        },
        {
          column: 'date',
          title: _vm.$t('purchasePayments.paymentDate'),
          type: 'text',
          sort: true,
        },
        {
          column: 'bill_id',
          title: _vm.$t('purchasePayments.bill'),
          type: 'linkInvoice',
          to: 'bill',
          sort: true,
          link: true,
        },
        {
          column: 'description',
          title: _vm.$t('purchasePayments.thatsAbout'),
          type: 'text',
          sort: true,
        },
        {
          column: 'cost',
          title: _vm.$t('purchasePayments.amount'),
          type: 'text',
          sort: true,
        },
        {
          column: 'options',
          title: _vm.$t('purchasePayments.settings'),
          type: 'options',
          options: [
            { name: 'show' },
            {
              name: 'edit',
              role:
                _vm.$user.admin ||
                _vm.$user.role.purchase_payments_edit,
            },
            { name: 'printPurchasePayment', role: true },
            { name: 'download', role: true },
            {
              name: 'delete',
              role:
                _vm.$user.admin ||
                _vm.$user.role.purchase_payments_delete,
            } ],
        } ],"deleteText":{
        attention: _vm.$t('allerts.Attention'),
        areYouReallySureToDeleteTheItem:
          _vm.$t('allerts.areYouReallySureToDeleteTheItem'),
        close: _vm.$t('allerts.close'),
        confirm: _vm.$t('allerts.confirm'),
        loading: _vm.$t('allerts.loading'),
      }}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }